import React from 'react';
import { styled } from '@linaria/react';
const OverlayRightShape = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 188 144">
      <path fill="#3E008A" d="M164.969 0c17.703 0 28.767 19.188 19.916 34.539l-53.309 92.443A33.989 33.989 0 0 1 102.135 144H20.027c-15.394 0-25.015-16.686-17.318-30.034l55.906-96.948A33.988 33.988 0 0 1 88.057 0h76.912Z" />
    </svg>;
};
const OverlayLeftShape = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 164 146">
      <path fill="#4E00AD" d="M144.368 0c15.09 0 24.522 16.2 16.976 29.16L98.98 136.277c-7.544 12.961-26.41 12.963-33.955.003L2.655 29.159C-4.89 16.2 4.543 0 19.633 0h124.736Z" />
    </svg>;
};
const Background = /*#__PURE__*/styled('div')({
  name: "Background",
  class: "b1enwu37",
  propsAsIs: false
});
const RightShapeWrapper = /*#__PURE__*/styled('div')({
  name: "RightShapeWrapper",
  class: "r5i0w9u",
  propsAsIs: false
});
const LeftShapeWrapper = /*#__PURE__*/styled('div')({
  name: "LeftShapeWrapper",
  class: "l1imurl1",
  propsAsIs: false
});
export const GradientBackground = () => {
  return <Background>
      <RightShapeWrapper>
        <OverlayRightShape />
      </RightShapeWrapper>
      <LeftShapeWrapper>
        <OverlayLeftShape />
      </LeftShapeWrapper>
    </Background>;
};

require("./GradientBackground.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./GradientBackground.tsx");